import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/google_for_jobs_qr_placeholder.svg?webp'


const _withScopeId = n => (_pushScopeId("data-v-e3d9fdd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qr-code-modal-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { PropType, ref, watch } from "vue";
import QRCodeCanvas from "@/components/atoms/other/QRCodeCanvas.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppInstallationGuidingModal',
  props: {
  isVisible: {
    type: Boolean,
    required: true
  },
  closeModal: {
    type: Function as PropType<() => void>,
    required: true
  },
  appInstallationPortalURL: {
    type: Function as PropType<() => string>,
    required: true
  },
  qrCodeLib: {
    type: Object as PropType<{
      toCanvas: (canvas: HTMLCanvasElement, url: string) => Promise<void>;
    }>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const reactiveVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  toggled => {
    reactiveVisible.value = toggled;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    id: "application-installation-guiding-modal-container",
    modelValue: reactiveVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reactiveVisible).value = $event)),
    onHide: __props.closeModal,
    "hide-footer": "",
    "hide-header": "",
    centered: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createVNode(QRCodeCanvas, {
          "url-provider": __props.appInstallationPortalURL,
          "qr-code-lib": props.qrCodeLib,
          class: "qr-code-canvas"
        }, null, 8, ["url-provider", "qr-code-lib"])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modelValue", "onHide"]))
}
}

})